import api from '@/api/survey'

const state = {
  fromPagePath: null
}

const actions = {
  searchSurvey ({ commit }, params) {
    return api.searchSurvey(params)
  },
  getSurveyById ({ commit }, id) {
    return api.getSurveyById(id)
  },
  updateSurvey ({ commit }, survey) {
    return api.updateSurvey(survey)
  },
  getSurveyInfo ({ commit }, companyId) {
    return api.getSurveyInfo(companyId)
  },
  getSurveyQuestion ({ commit }, companyId) {
    return api.getSurveyQuestion(companyId)
  },
  answerSurveyQuestion ({ commit }, { companyId, question }) {
    return api.answerSurveyQuestion(companyId, question)
  },
  getSurveyPreference ({ commit }, params) {
    return api.getSurveyPreference(params)
  },
  updateSurveyPreference ({ commit }, { companyId, preference }) {
    return api.updateSurveyPreference(companyId, preference)
  },
  setFromPath ({ commit }, path) {
    commit('SET_FROM_PAGE_PATH', path)
  },
  getCompanySurveySimpleInfo ({ commit }, companyId) {
    return api.getCompanySurveySimpleInfo(companyId)
  },
  getCompanySurveyQuestionList (context, params) {
    return api.getCompanySurveyQuestionList(params)
  }
}

const mutations = {
  SET_FROM_PAGE_PATH (state, path) {
    state.fromPagePath = path
  }
}

const getters = {
  fromPagePath: state => {
    return state.fromPagePath
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
